import React, { FC } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../../../models";
import { PickupPoint } from "../../../../../../models/state";
import * as LOADING_SELECTORS from "../../../../loading/state/selectors";
import { PickupPointList } from "../../../../pickup-points";
import * as PICK_UP_POINT_AT from "../../../../pickup-points/state/actionTypes";
import { getPickupPointPoints } from "../../../../pickup-points/state/selectors";
import { getDeliveryInfoCode, getDeliveryInfoZipCode } from "../../../state/selectors/deliveryInfoSelectors";

interface StateProps {
    deliveryInfoZipCode?: string;
    isLoadingPickupPoints: boolean;
    pickupPoints: PickupPoint[];
    selectedPointCode?: string;
}

interface ConnectedPickupPointListProps extends StateProps {
    onPointSelected: (code: string, zipCode: string) => void;
}

const ConnectedPickupPointList: FC<ConnectedPickupPointListProps> = ({
    selectedPointCode = "",
    pickupPoints,
    onPointSelected,
    isLoadingPickupPoints,
    deliveryInfoZipCode = "",
}) => {
    if (isLoadingPickupPoints) {
        return null;
    }

    return (
        <PickupPointList
            selectedPointCode={selectedPointCode}
            pickupPoints={pickupPoints}
            onPointSelected={(code): void => onPointSelected(code, deliveryInfoZipCode)}
        />
    );
};
const mapStateToProps: (state: RootState) => StateProps = (state) => ({
    selectedPointCode: getDeliveryInfoCode(state),
    deliveryInfoZipCode: getDeliveryInfoZipCode(state),
    pickupPoints: getPickupPointPoints(state),
    isLoadingPickupPoints: LOADING_SELECTORS.isTypeLoading(state, PICK_UP_POINT_AT.PICKUP_POINTS_FETCH_PICKUP_POINTS),
});

export default connect(mapStateToProps)(ConnectedPickupPointList);
